// «Buscar actualizaciones», para cuando la app YA está instalada.
//
// Observación de Patricio: en un Android con el APK puesto seguía saliendo
// «Instalar Ona Pulse en el móvil», que ahí no significa nada. Lo que hace falta
// es lo contrario: poder pedirle que se ponga al día.
//
// Cómo funciona de verdad: la app se actualiza SOLA al abrirla —descarga el
// paquete nuevo por el aire y lo aplica— así que este botón no es la vía
// normal, es el «ahora». Sirve para dos momentos concretos: cuando alguien está
// mirando la app y le acabas de publicar algo, y cuando hay que descartar que
// el problema sea una versión vieja.
//
// 🔴 Y dice la verdad cuando no puede: una actualización por aire solo llega si
// la HUELLA del binario coincide con la del paquete publicado. Si se tocó algo
// nativo —un icono, un permiso, la configuración de construcción— hace falta un
// APK nuevo, y entonces esto no encontrará nada por más que se pulse. Antes de
// que eso parezca un fallo, se explica.
import React, { useState } from 'react';
import { Platform, Pressable, StyleSheet, Text, View } from 'react-native';
import * as Updates from 'expo-updates';
import { APP_VERSION } from '@/api/client';
import { C, F, R } from '@/constants/theme';

type Estado = 'quieto' | 'buscando' | 'bajando' | 'aldia' | 'lista' | 'nopuede';

export default function Actualizar() {
  const [estado, setEstado] = useState<Estado>('quieto');
  const [nota, setNota] = useState<string | null>(null);

  const buscar = async () => {
    setNota(null);
    setEstado('buscando');
    try {
      const r = await Updates.checkForUpdateAsync();
      if (!r.isAvailable) {
        setEstado('aldia');
        return;
      }
      setEstado('bajando');
      await Updates.fetchUpdateAsync();
      setEstado('lista');
    } catch (e) {
      /* Lo más común: el paquete publicado tiene otra huella (se tocó algo
         nativo). También pasa sin red. Se distingue por el mensaje. */
      setEstado('nopuede');
      setNota(e instanceof Error ? e.message : null);
    }
  };

  const txt = {
    quieto: 'Buscar actualizaciones',
    buscando: 'Buscando…',
    bajando: 'Descargando…',
    aldia: '✓ Ya estás en la última',
    lista: 'Toca para reiniciar y aplicarla',
    nopuede: 'No se pudo comprobar',
  }[estado];

  return (
    <View>
      <Pressable
        style={[s.btn, estado === 'lista' && s.btnListo]}
        onPress={estado === 'lista' ? () => Updates.reloadAsync() : buscar}
        disabled={estado === 'buscando' || estado === 'bajando'}
      >
        <Text style={[s.txt, estado === 'lista' && { color: '#04252A' }]}>{txt}</Text>
      </Pressable>

      <Text style={s.pie}>
        {estado === 'nopuede'
          ? 'Puede ser la red, o que esta versión de la app necesite un instalador nuevo '
            + '(pasa cuando se cambia algo del propio programa y no solo de las pantallas). '
            + 'Díselo a Sistemas.'
          : estado === 'aldia'
            ? `Versión ${APP_VERSION}. La app se pone al día sola al abrirla; esto es para forzarlo.`
            : `Versión ${APP_VERSION} · ${Updates.isEmbeddedLaunch ? 'la del instalador' : 'actualizada por el aire'}`}
      </Text>
      {nota && estado === 'nopuede' ? <Text style={s.err}>{nota}</Text> : null}
    </View>
  );
}

/** ¿Estamos dentro de la app instalada, o en el navegador? */
export const appInstalada = Platform.OS !== 'web';

const s = StyleSheet.create({
  btn: {
    borderWidth: 1, borderStyle: 'dashed', borderColor: 'rgba(30,211,199,0.45)',
    borderRadius: 16, padding: 13, alignItems: 'center', marginTop: 8,
  },
  btnListo: { backgroundColor: C.aqua, borderStyle: 'solid', borderColor: C.aqua },
  txt: { fontFamily: F.uiSemi, fontSize: 12.5, color: C.aquaSoft },
  pie: { fontFamily: F.ui, fontSize: 10, color: C.faint, textAlign: 'center', marginTop: 7, lineHeight: 15 },
  err: { fontFamily: F.ui, fontSize: 9.5, color: C.bad, textAlign: 'center', marginTop: 5 },
});
